import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { fullMonthNames } from "../../../common/data/monthName";

import "react-datepicker/dist/react-datepicker.css";
import "flatpickr/dist/themes/material_blue.css";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ConvertDate, generateDateArray } from "../../Function/ConvertDate";
import MyThaiDatePick from "../../../components/Common/ThaiDatePicker";
import NewThaiDatePicker from "../../../components/Common/NewThaiDatePicker";
import { CheckBudgetYear } from "../../Function/CheckBudgetYear";
import da from "date-fns/esm/locale/da/index.js";
import { FetchAxiosGet } from "../../../api/axios";
import { checkFinalApprove } from "../../Function/CheckFinalApprove";
import { get } from "lodash";
import Lottie from "react-lottie";
import FadeIn from "react-fade-in/lib/FadeIn";
import * as loadingBar from "../../TESTPage/loadingBar.json";
import { leaveConfigFlow } from "../LeaveStepHelper";

const Form1 = ({
  userInfo,
  closeCanvas,
  configForm,
  getLeaveData,
  RefreshLeaveDataTable,
  activeTabNav,
  setActiveTabNav,
  isFromIndex,
  navigateState
}) => {
  const [fileKey, setFileKey] = useState(0);
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const userPosition = GetCookieData("userPosition");
  const user_id = user?.user_id;
  const user_position =
  userPosition &&
  userPosition
    .sort((a, b) => a?.position_id - b?.position_id)
    ?.find((a) =>
      a?.position_id === 2
        ? 2
        : a?.position_id === 3
        ? 3
        : a?.position_id === 4
        ? 4
        : a?.position_id === 5
        ? 5
        : a?.position_id === 6
        ? 6
        : a?.position_id === 7
        ? 7
        : null
    )?.position_id;

  const [holiday, setHoliday] = useState([]);

  ////////////////////////////// เกี่ยวกับการแก้ไขบางวันของลาพักผ่อน
  const [startCancel, setStartCancel] = useState();
  const [endCancel, setEndCancel] = useState();
  const [allDayCancel, setAllDayCancel] = useState([]);
  const [selectDayCancel, setSelectDayCancel] = useState([]);
  const [leavePerson, setLeavePerson] = useState([]);
  const [leaveVacation, setLeaveVacation] = useState([]);
  const [checkRangeLeaveDataFromSelectBool, setCheckRangeLeaveDataFromSelectBool] = useState(true)
  const [vacationRemain, setVacationRemain] = useState({
    vacationDayPrev : null,
    vacationUse : null,
    vacationRemaining : null,
  });
  const [isLeaveDayZero, setIsLeaveDayZero] = useState(false);
  const [reqRefLeaveDay, setReqRefLeaveDay] = useState(false);
  const [validateForm, setValidateForm] = useState({
    abroad_ref: false,
    abroad_ref_2: false,
  });
  const [data, setData] = useState({
    //show in form only
    user_id: userInfo?.user_id,
    user_name: userInfo?.user_name,
    user_position_name: userInfo?.user_position_name,
    cont_to_name_1: userInfo?.cont_to,
    writeFrom: "สำนักงาน ก.พ.ร.",
    writeDate: new Date().toLocaleDateString(),

    //required field
    leave_type_id: configForm?.leave_type[0]?.leave_type_id,
    form_type: configForm?.form_type,
    form_name: configForm?.form_name,
    budget_year: CheckBudgetYear(),
    leave_name:
      configForm?.form_type !== 1 &&
      configForm?.form_type !== 7 &&
      configForm?.form_type !== 11
        ? configForm?.leave_type[0]?.leave_name
        : configForm?.form_type === 1
        ? `ขอ${configForm?.leave_type[0]?.leave_name}`
        : configForm?.form_type === 11
        ? `${configForm?.leave_type[0]?.leave_name}`
        : "",
    // send_to: "ผู้อำนวยการสำนักงานเลขาธิการ",
    send_to: '',
    leave_from_date: new Date(new Date().setHours(0, 0, 0, 0)),
    leave_from_timetype: "1",
    leave_to_date: new Date(new Date().setHours(0, 0, 0, 0)),
    leave_to_timetype: "2",
    leave_days: "",
    leave_status: "4",
    approve_status: "0",
    approve_user_id: userInfo?.leader?.user_id,
    approve_user: userInfo?.leader?.user_name,

    //non required field
    leave_reason: "",
    contact_address: "",
    abroad_for: "",
    abroad_country: "",
    abroad_ref: "",
    abroad_ref_2: "",
    ordinate_ever: "",
    ordinate_temple: "",
    ordinate_temple_place: "",
    ordinate_date: "",
    ordinate_live_temple: "",
    ordinate_live_place: "",
    hujj_ever: "",
    conscription_from: "",
    conscription_place: "",
    conscription_date: "",
    conscription_for: "",
    conscription_to_place: "",
    training_fund_from: "",
    spouse_name: "",
    spouse_position: "",
    spouse_department: "",
    spouse_country: "",
    spouse_from_date: "",
    spouse_to_date: "",
    spouse_years: "",
    spouse_months: "",
    spouse_days: "",
    outside_place: "",
    practice_type: "",
    practice_reason: "",

    note: "",
    leave_group: "",
    file_data: null,
    org_name: "",
    position_name: ""
  });
  
  const [leaveDayAll, setLeaveDayAll] = useState(0)
  const [flowLoading, setFlowLoading] = useState(false)

  const [submitSending, setSubmitSending] = useState(false)

  useEffect(() => {
    if(selectDayCancel?.length > 0 || allDayCancel?.length > 0) {
      allDayCancel?.sort((a, b) => new Date(a?.date_cancel) - new Date(b?.date_cancel))
      selectDayCancel?.sort((a, b) => new Date(a?.date_cancel) - new Date(b?.date_cancel))
    }
  }, [allDayCancel, selectDayCancel]);

  const formValidate = useFormik({
    enableReinitialize: true,

    initialValues: {
      leave_reason: "",
      abroad_for: "",
      abroad_country: "",
      ordinate_ever: "",
      ordinate_temple: "",
      ordinate_temple_place: "",
      ordinate_live_temple: "",
      ordinate_live_place: "",
      conscription_from: "",
      conscription_place: "",
      conscription_date: "",
      conscription_for: "",
      conscription_to_place: "",
      leave_name: "",
      spouse_name: "",
      spouse_country: "",
      outside_place: "",
      practice_reason: "",
      contact_address: "",
    },

    validationSchema: Yup.object().shape({
      leave_reason: Yup.string().when("configForm", {
        is: () =>
          configForm?.form_type === 1 || configForm?.form_type === 11
            ? true
            : false,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      abroad_for: Yup.string().when("configForm", {
        is: () => (configForm?.form_type === 3 || configForm?.form_type === 7) && true,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      abroad_country: Yup.string().when("configForm", {
        is: () =>
          configForm?.form_type === 3 || configForm?.form_type === 7
            ? true
            : false,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      ordinate_temple: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 4,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      ordinate_temple_place: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 4,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      ordinate_live_temple: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 4,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      ordinate_live_place: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 4,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      conscription_from: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 6,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      conscription_place: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 6,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      conscription_for: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 6,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      conscription_to_place: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 6,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      // leave_name: Yup.string().when("configForm", {
      //   is: () => configForm?.form_type === 7,
      //   then: Yup.string().required("กรุณาระบุสถานที่ติดต่อ"),
      //   otherwise: Yup.string().notRequired(),
      // }),
      spouse_name: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 8,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      spouse_country: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 8,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      outside_place: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 9,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      practice_reason: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 10,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      contact_address: Yup.string().when("configForm", {
        is: () =>
          configForm?.form_type === 1 || configForm?.form_type === 2
            ? true
            : false,
        then: Yup.string().required("กรุณาระบุสถานที่ติดต่อ"),
        otherwise: Yup.string().notRequired(),
      }),
    }),
    onSubmit: async (values) => {
      try {
        if (data?.leave_days === 0 && (data?.form_type !== 3)) {
          setIsLeaveDayZero(true);
        } else {
          let refleaveDay = (leaveVacation.find((x) => x?.leave_data_id === data.abroad_ref)?.leave_days || 0) + (leavePerson.find((x) => x?.leave_data_id === data.abroad_ref_2)?.leave_days || 0)
          if ((data?.leave_rest_day > refleaveDay) && configForm?.form_type === 3) {
            setReqRefLeaveDay(true);
          } else {
            setSubmitSending(true)
            const res = await axios.post(
            `${baseURL}/api/leave/save`,
            {
              leave_type_id: data?.leave_type_id, //ประเภทใบลา
              form_type: data?.form_type, //ประเภทฟอร์มการลา
              form_name: data?.form_name, //ชื่อฟอร์มการลา
              budget_year: data?.budget_year, //ปีงบประมาณ
              leave_name: data?.leave_name, //ชื่อเรื่องการลา
              send_to: data?.send_to, //เรียน
              leave_from_date: ConvertDate(data?.leave_from_date)?.toDateISO(), //ตั้งแต่วันที่
              leave_from_timetype: data?.leave_from_timetype, //ช่วงเวลา
              leave_to_date: ConvertDate(data?.leave_to_date)?.toDateISO(), //ถึงวันที่
              leave_to_timetype: data?.leave_to_timetype, //ช่วงเวลา
              leave_days: data?.leave_days, //กำหนดหรือจำนวนวัน
              change_days: data?.leave_days,

              leave_reason:
                configForm?.form_type === 1 || configForm?.form_type === 11
                  ? values?.leave_reason
                  : undefined, //เนื่องจาก

              contact_address:
                configForm?.form_type === 1 || configForm?.form_type === 2
                  ? values?.contact_address
                  : undefined, //สถานที่ติดต่อ
              abroad_for:
                configForm?.form_type === 3 || configForm?.form_type === 7 ? data?.abroad_for : undefined, //เพื่อไป
              abroad_country:
                configForm?.form_type === 3 || configForm?.form_type === 7
                  ? data?.abroad_country
                  : undefined, //ณ ประเทศ
              abroad_ref:
                configForm?.form_type === 3 ? data?.abroad_ref : undefined, //ไอดีลากิจหรือลาพักผ่อน
              abroad_ref_2:
                configForm?.form_type === 3 ? data?.abroad_ref_2 : undefined, //ไอดีลากิจหรือลาพักผ่อน
              ordinate_ever:
                configForm?.form_type === 4 ? data?.ordinate_ever : undefined, //เคยอุปสมบทไหม
              ordinate_temple:
                configForm?.form_type === 4 ? data?.ordinate_temple : undefined, //จะอุปสมบท ณ วัด
              ordinate_temple_place:
                configForm?.form_type === 4
                  ? data?.ordinate_temple_place
                  : undefined, //ตั้งอยู่ ณ
              ordinate_date:
                configForm?.form_type === 4 ? ConvertDate(data?.ordinate_date)?.toDateISO() : undefined, //วันที่อุปสมบท
              ordinate_live_temple:
                configForm?.form_type === 4
                  ? data?.ordinate_live_temple
                  : undefined, //จำพรรษา ณ วัด
              ordinate_live_place:
                configForm?.form_type === 4
                  ? data?.ordinate_live_place
                  : undefined, //ตั้งอยู่ ณ
              hujj_ever:
                configForm?.form_type === 5 ? data?.hujj_ever : undefined,
              conscription_from:
                configForm?.form_type === 6
                  ? data?.conscription_from
                  : undefined,
              conscription_place:
                configForm?.form_type === 6
                  ? data?.conscription_place
                  : undefined,
              conscription_date:
                configForm?.form_type === 6
                  ? ConvertDate(data?.conscription_date)?.toDateISO()
                  : undefined,
              conscription_for:
                configForm?.form_type === 6
                  ? data?.conscription_for
                  : undefined,
              conscription_to_place:
                configForm?.form_type === 6
                  ? data?.conscription_to_place
                  : undefined,
              training_fund_from:
                configForm?.form_type === 7
                  ? data?.training_fund_from ?? undefined
                  : undefined,
              spouse_name:
                configForm?.form_type === 8 ? data?.spouse_name : undefined,
              spouse_position:
                configForm?.form_type === 8 ? data?.spouse_position : undefined,
              spouse_department:
                configForm?.form_type === 8
                  ? data?.spouse_department
                  : undefined,
              spouse_country:
                configForm?.form_type === 8 ? data?.spouse_country : undefined,
              spouse_from_date:
                configForm?.form_type === 8
                  ? ConvertDate(data?.spouse_from_date)?.toDateISO()
                  : undefined,
              spouse_to_date:
                configForm?.form_type === 8 ? ConvertDate(data?.spouse_to_date)?.toDateISO() : undefined,
              outside_place:
                configForm?.form_type === 9 ? data?.outside_place : undefined,
              practice_reason:
                configForm?.form_type === 10
                  ? data?.practice_reason
                  : undefined,

              note: data?.note || "", //หมายเหตุ
              user_id: data?.user_id, //ไอดีผู้ส่งฟอร์ม
              leave_status: data?.leave_status, //สถานะใบลา
              approve_status: data?.approve_status, //สถานะการอนุมัติ
              approve_user_id: data?.approve_user_id,
              approve_user: data?.approve_user,
              approve_final: 0,
              org_name : data?.org_name,
              position_name : data?.position_name
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          await handleSentFile(res?.data?.insertedId);
          selectDayCancel &&
            selectDayCancel?.map(async (item) => {
              await SubmitCancelLeaveDay(item, res?.data?.insertedId);
            });
          setSubmitSending(false)
          if (isFromIndex) {
            RefreshLeaveDataTable(isFromIndex);
          } else {
            getLeaveData(1, isFromIndex);
          }
          await closeCanvas();
          if (activeTabNav === "1") {
            setActiveTabNav((prev) => "2");
          }
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
  });

  const [leaveDataFromSelect, setLeaveDataFromSelect] = useState([])
  const [leaveDataCanCelDateDataTable, setLeaveDataCanCelDateDataTable] = useState([])
  const [checkLeaveDataFromSelect, setCheckLeaveDataFromSelect] = useState(false)


  useEffect(() => {
    getLeaveDataFromSelect()
  }, [data.leave_from_date, data.leave_to_date, data.leave_from_timetype, data.leave_to_timetype])
  

  const getLeaveDataFromSelect = async () => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[budget_year][0]": CheckBudgetYear(),
        "filter[leave_status][0]": 0,
        "filter[leave_status][1]": 2,
        "filter[leave_status][2]": 3,
        "filter[leave_status][3]": 4,
        "filter[leave_status][4]": 5,
        "filter[leave_status][5]": 7,
        "filter[leave_status][6]": 9,
        "filter[leave_status][7]": "C",
        "filter[leave_dmy_start][0]": ConvertDate(data?.leave_from_date)?.toDateISO(),
        "filter[leave_dmy_end][0]": ConvertDate(data?.leave_to_date)?.toDateISO(),
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      if (configForm?.form_type !== 3) {
        setLeaveDataFromSelect(res?.data?.result);
        setCheckLeaveDataFromSelect(true)
        res?.data?.result.forEach(async element => {
          await checkLeaveDateCancel(element?.leave_data_id)
        });
        
      }
      // configForm?.form_type !== 3 && setLeaveDataFromSelect(res?.data?.result); setCheckLeaveDataFromSelect(true)
    } catch (err) {
      console.error(err);
    }
  };

  const calculateLeaveDays = (
    leavefromDate,
    leavefromTime,
    leavetoDate,
    leavetoTime,
    countAll = false,
  ) => {
    let sum = 0;

    const leaveTypeId = Number(data?.leave_type_id);
    const thisLeaveType = configForm?.leave_type
    const ignoreHolidayLeaveConfig = thisLeaveType?.find(t => t.leave_type_id === leaveTypeId)?.ignoreHoliday ?? false;
    
    const ignoreHoliday = countAll ? false : (ignoreHolidayLeaveConfig)
    
    // console.log(leaveTypeId, thisLeaveType, ignoreHolidayLeaveConfig, ignoreHoliday);

    const isWeekend = (date) => {
      const day = new Date(date)?.getDay();
      return day === 6 || day === 0; // 6 คือวันเสาร์, 0 คือวันอาทิตย์
    };

    const isThaiPublic = (date) => {
      const localDate = new Date(date);
      localDate.setHours(0, 0, 0, 0);
      return holiday.some((item) => {
        const startDate = new Date(item?.date_start_holiday)?.setHours(
          0,
          0,
          0,
          0
        );
        const endDate = new Date(item?.date_end_holiday)?.setHours(0, 0, 0, 0);
        return localDate >= startDate && localDate <= endDate;
      });
    };

    if (leavefromTime === "1" && leavetoTime === "2") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (ignoreHoliday) {
          if (!isWeekend(i) && !isThaiPublic(i)) {
            sum++;
          }
        } else {
          sum++;
        }
      }
      sum = sum - 0;
      return sum;
    }
    if (leavefromTime === "1" && leavetoTime === "1") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (ignoreHoliday) {
          if (!isWeekend(i) && !isThaiPublic(i)) {
            sum++;
          }
        } else {
          sum++;
        }
      }
      sum = sum === 0 ? sum : sum - 0.5;
      return sum;
    }
    if (leavefromTime === "2" && leavetoTime === "2") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (ignoreHoliday) {
          if (!isWeekend(i) && !isThaiPublic(i)) {
            sum++;
          }
        } else {
          sum++;
        }
      }
      sum = sum === 0 ? sum : sum - 0.5;
      return sum;
    }
    if (leavefromTime === "2" && leavetoTime === "1") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (ignoreHoliday) {
          if (!isWeekend(i) && !isThaiPublic(i)) {
            sum++;
          }
        } else {
          sum++;
        }
      }
      sum = sum - 1;
      return sum;
    }

  };

  const handleSentFile = async (id) => {
    const formData = new FormData();
    formData.append("file", data?.file_data);
    try {
      const res = await axios.post(
        baseURL + `/api/leave/file/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (err) {
      console.error(err);
    }
  };

  console.log(userInfo, userInfo?.user_position_name);

  useEffect(() => {
    const leaderInfo = userInfo?.leader
    let sendTo = `${leaderInfo ? ((leaderInfo.assign === 1 ? 
      (leaderInfo?.assigned_by_user?.user_name ?? leaderInfo?.user_name) : leaderInfo?.user_name) + "-" + 
      (userInfo?.cont_to_id === 52 ? (leaderInfo?.user_position_name) : (leaderInfo?.user_position_name_dis ?? "") + (leaderInfo?.org_name ?? ""))) : ""}`

    setData((prev) => ({
      ...prev,
      user_id: userInfo?.user_id,
      user_name: userInfo?.user_name,
      user_position_name: userInfo?.user_position_name,
      cont_to_name_1: userInfo?.cont_to,
      writeFrom: "สำนักงาน ก.พ.ร.",
      writeDate: new Date(),

      //required field
      leave_type_id: configForm?.leave_type[0]?.leave_type_id,
      form_type: configForm?.form_type,
      form_name: configForm?.form_name,
      budget_year: CheckBudgetYear(),
      leave_name:
        configForm?.form_type !== 1 &&
        configForm?.form_type !== 7 &&
        configForm?.form_type !== 11
          ? configForm?.leave_type[0]?.leave_name
          : configForm?.form_type === 1
          ? `ขอ${configForm?.leave_type[0]?.leave_name}`
          : configForm?.form_type === 11
          ? `${configForm?.leave_type[0]?.leave_name}`
          : "",
      // send_to: "ผู้อำนวยการสำนักงานเลขาธิการ",
      // send_to: userInfo?.leader ? (userInfo?.leader?.position_id < 7 ? `${userInfo?.leader?.user_position_name_dis ?? ''}${userInfo?.leader?.position_id <= 4 ? '' : userInfo?.leader?.org_name ?? ''}` : `${userInfo?.leader?.user_position_name ?? `${userInfo?.leader?.user_position_name_dis ?? ''}${userInfo?.leader?.org_name ?? ''}`}`) : 'ไม่พบข้อมูล',
      send_to: sendTo,
      leave_from_date: new Date(new Date(configForm?.form_type === 10 && navigateState ? navigateState : new Date()).setHours(0, 0, 0, 0)),
      leave_from_timetype: "1",
      leave_to_date: new Date(new Date(configForm?.form_type === 10 && navigateState ? navigateState : new Date()).setHours(0, 0, 0, 0)),
      leave_to_timetype: "2",
      leave_days: calculateLeaveDays(
        new Date(new Date().setHours(0, 0, 0, 0)),
        "1",
        new Date(new Date().setHours(0, 0, 0, 0)),
        "2"
      ),
      leave_status: "4",
      approve_status: "0",
      approve_user_id: userInfo?.leader?.user_id,
      approve_user: userInfo?.leader?.user_name,

      //non required field
      leave_reason: "",
      contact_address: "",
      abroad_for: "",
      abroad_country: "",
      abroad_ref: "",
      abroad_ref_2: "",
      ordinate_ever: "",
      ordinate_temple: "",
      ordinate_temple_place: "",
      ordinate_date: "",
      ordinate_live_temple: "",
      ordinate_live_place: "",
      hujj_ever: "",
      conscription_from: "",
      conscription_place: "",
      conscription_date: "",
      conscription_for: "",
      conscription_to_place: "",
      training_fund_from: "",
      spouse_name: "",
      spouse_position: "",
      spouse_department: "",
      spouse_country: "",
      spouse_from_date: "",
      spouse_to_date: "",
      spouse_years: "",
      spouse_months: "",
      spouse_days: "",
      outside_place: "",
      practice_type: "",
      practice_reason: "",

      note: "",
      leave_group: "",
      file_data: null,
      org_name: userInfo?.cont_to_name_1,
      position_name: userInfo?.user_position_name
    }));
  }, [configForm]);

  const handleInputChange = (e, field) => {
    if (configForm?.form_type === 3) {
      setData((prev) => ({
        ...prev,
        [field]: e?.target?.value,
      }));
    } else {
      setData((prev) => ({
        ...prev,
        [field]: e?.target?.value,
      }));
    }
  };

  ////////////////////// รับวันหยุดราชการจาก database
  const getHoliday = async (prevYear, year, nextYear = null) => {
    try {
      // if (next_year) {
        setHoliday([])
        const year_arr =[prevYear, year, nextYear]
        const res_arr = []
        for await (const element_year of year_arr) {
          const res = await axios.get(baseURL + `/api/masterdata/holiday/${element_year}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          res_arr.push(res?.data?.result)
        }
        setHoliday(res_arr.flat());
      // } else {
      //   const res = await axios.get(baseURL + `/api/masterdata/holiday/${year}`, {
      //     headers: { Authorization: `Bearer ${token}` },
      //   });
      //   setHoliday(res?.data?.result);
      // }

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getHoliday(new Date()?.getFullYear() - 1, new Date()?.getFullYear(), new Date()?.getFullYear() + 1);
    getLeaveDataFromSelect()
  }, []);

  /////////////////// รับวันลากิจของ user นั้นๆ จาก database
  const getLeavePerson = async (dmy_s = null, dmy_t = null) => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 5,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[form_type][0]": 1,
        "filter[leave_type_id][0]": 2,
        "filter[leave_dmy_start][0]": ConvertDate(new Date(dmy_s)).toOnlyDate() ?? ConvertDate(new Date()).toOnlyDate(),
        "filter[leave_dmy_end][0]": ConvertDate(new Date(dmy_t)).toOnlyDate() ?? ConvertDate(new Date()).toOnlyDate(),
        "filter[leave_status][0]": 5,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLeavePerson(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  /////////////////// รับวันลาพักผ่อนของ user นั้นๆ จาก database
  const getLeaveVacation = async (dmy_s = null, dmy_t = null) => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 5,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[form_type][0]": 2,
        "filter[leave_dmy_start][0]": ConvertDate(new Date(dmy_s)).toOnlyDate() ?? ConvertDate(new Date()).toOnlyDate(),
        "filter[leave_dmy_end][0]": ConvertDate(new Date(dmy_t)).toOnlyDate() ?? ConvertDate(new Date()).toOnlyDate(),
        "filter[leave_status][0]": 5,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      if (res?.data?.result?.length > 0) {
        setLeaveVacation(res?.data?.result);
      } else {
        setLeaveVacation([]);
      }
      
    } catch (err) {
      console.error(err);
    }
  };

  const convertDate = (date) => {
    const DateSplit = {
      toDate: () => {
        const part1 = date?.split("T")[0];
        const part2 = part1.split("-")[2];
        return part2;
      },
      toMonth: () => {
        const part1 = date?.split("T")[0];
        const part2 = part1.split("-")[1];
        return fullMonthNames[part2 - 1];
      },
      toYear: () => {
        const part1 = date?.split("T")[0];
        const part2 = part1.split("-")[0];
        return parseInt(part2) + 543;
      },
    };

    return DateSplit;
  };

  useEffect(() => {
    if (configForm?.form_type === 2) {
      getVacationRemain();
      getAllDayCancel(data?.leave_from_date, data?.leave_to_date);
    }
    // if (configForm?.form_type === 3) {
    //   getLeavePerson();
    //   getLeaveVacation();
    // }
  }, [configForm]);
  

  const getVacationRemain = async () => {
    try {
      const res = await axios.get(
        baseURL + `/api/leave/chart/1/${CheckBudgetYear()}/${user_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let result = res?.data?.result;
      let vacationDayPrev = 0;
      let vacationUse = 0;
      let vacationRemaining = 0;
      vacationDayPrev = result?.years_worked >= 10
            ? (result?.vacation_limit_day?.max + (result?.vacation_over10?.vacation_day_prev || 0)) > 30
              ? 30 : result?.vacation_limit_day?.max + (result?.vacation_over10?.vacation_day_prev || 0)
            : (result?.vacation_limit_day?.max + (result?.vacation_under10?.vacation_day_prev || 0)) > 30 
              ? 30 : result?.vacation_limit_day?.max + (result?.vacation_under10?.vacation_day_prev || 0)
      vacationUse = result?.vacation_limit_day?.use
      vacationRemaining = vacationDayPrev - vacationUse;
      setVacationRemain((prev) => ({
        ...prev,
        vacationDayPrev : vacationDayPrev,
        vacationUse : vacationUse,
        vacationRemaining : vacationRemaining,
      }));
    } catch (err) {}
  };

  const SetStartEndCancel = async (leaveFromDate, leavetoDate) => {
    setStartCancel(leaveFromDate);
    setEndCancel(leavetoDate);
  };

  const getAllDayCancel = async (
    startCancel = new Date(),
    endCancel = new Date()
  ) => {
    const isWeekend = (date) => {
      const day = new Date(date)?.getDay();
      return day === 6 || day === 0; // 6 คือวันเสาร์, 0 คือวันอาทิตย์
    };

    const isThaiPublic = (date) => {
      const localDate = new Date(date);
      localDate.setHours(0, 0, 0, 0);
      return holiday.some((item) => {
        const startDate = new Date(item?.date_start_holiday)?.setHours(
          0,
          0,
          0,
          0
        );
        const endDate = new Date(item?.date_end_holiday)?.setHours(0, 0, 0, 0);
        return localDate >= startDate && localDate <= endDate;
      });
    };

    setAllDayCancel([]);
    let ref = [];

    for (
      let i = new Date(new Date(startCancel).setHours(0, 0, 0, 0));
      i <= new Date(new Date(endCancel).setHours(0, 0, 0, 0));
      i.setDate(i.getDate() + 1)
    ) {
      let currentDate = new Date(i);
      let newOBJ = {
        date_cancel: currentDate,
      };
      if (!isWeekend(i) && !isThaiPublic(i)) {
        ref.push(newOBJ);

        setAllDayCancel((prev) => [...prev, newOBJ]);
      }
    }
    return ref;
  };
  const calculateCancelLeaveDay = (
    leavefromType,
    leaveToType,
    leaveDays,
    eTarget,
    DateItem
  ) => {
    if (leavefromType === "1" && leaveToType === "2") {
      if (eTarget === "0") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
      if (eTarget === "1") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "1",
                }
              : item
          )
        );
        return leaveDays + 0.5;
      }
      if (eTarget === "2") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "2",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays + 0.5;
      }
    } else if (leavefromType === "1" && leaveToType === "1") {
      if (eTarget === "0") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays === 0 ? leaveDays : leaveDays - 0.5;
      }
      if (eTarget === "1") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "1",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
      if (eTarget === "2") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "2",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
    } else if (leavefromType === "2" && leaveToType === "2") {
      if (eTarget === "0") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays === 0 ? leaveDays : leaveDays - 0.5;
      }
      if (eTarget === "1") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "1",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
      if (eTarget === "2") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "2",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
    }
  };

  /////////////////////// บันทึกวันที่ต้องการยกเลิกลงใน database
  const SubmitCancelLeaveDay = async (item, id) => {
    try {
      const res = await axios.post(
        baseURL + "/api/leave/cancel/list/save",
        {
          leave_data_id: id,
          date_cancel: ConvertDate(item?.date_cancel)?.toOnlyDate(),
          leave_from_timetype: item?.leave_from_timetype,
          leave_to_timetype: item?.leave_to_timetype,
          cancel_date_status: 1
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    data?.leave_from_date > data?.leave_to_date && setData((prev) => ({
      ...prev,
      leave_to_date: data?.leave_from_date,
    }));
  }, [data?.leave_from_date])
  

  const setLeaveFromDate = (e) => {
    // if (data?.leave_to_date !== null) {
    //   const leaveDays = calculateLeaveDays(
    //     e,
    //     data?.leave_from_timetype,
    //     e,
    //     data?.leave_to_timetype
    //   );
    //   setData((prev) => ({
    //     ...prev,
    //     //leave_from_date: data.leave_from_date > data.leave_to_date ? data.leave_to_date : e,
    //     leave_from_date: e,
    //     leave_to_date: e,
    //     leave_days: leaveDays,
    //   }));
    // }
    setData((prev) => ({
      ...prev,
      leave_from_date: e,
      leave_to_date: e,
    }));
  }

  const setLeaveToDate = (e) => {
    // if (data.leave_from_date !== null) {
    //   const leaveDays = calculateLeaveDays(
    //     new Date(
    //       new Date(data?.leave_from_date).setHours(0, 0, 0, 0)
    //     ),
    //     data.leave_from_timetype,
    //     e,
    //     data.leave_to_timetype
    //   );
    //   setData((prev) => ({
    //     ...prev,
    //     leave_to_date: e,
    //     leave_days: leaveDays,
    //   }));
    // }
    if (configForm?.form_type === 2) {
      SetStartEndCancel(new Date(data?.leave_from_date), e);
      getAllDayCancel(new Date(data?.leave_from_date), e);
    }
    setData((prev) => ({ ...prev, leave_to_date: e }));
  }

  const setOrdinateDate = (e) => {
    setData((prev) => ({
      ...prev,
      ordinate_date: e,
    }));
  }

  const setConscriptionDate = (e) => {
    setData((prev) => ({
      ...prev,
      conscription_date: e,
    }));
  }

  const setSpouseFromDate = (e) => {
    setData((prev) => ({
      ...prev,
      spouse_from_date: e,
      spouse_to_date: e,
    }));
  }

  const setSpouseToDate = (e) => {
    setData((prev) => ({
      ...prev,
      spouse_to_date: e,
    }));
  }

  useEffect(() => {
    let leaveDays;
    let leaveDayAll;
    if (configForm?.form_type === 3) {
      leaveDays = calculateLeaveDays(
        data?.leave_from_date,
        data?.leave_from_timetype,
        data.leave_to_date,
        data?.leave_to_timetype,
        false
      )
      leaveDayAll = calculateLeaveDays(
        data?.leave_from_date,
        data?.leave_from_timetype,
        data.leave_to_date,
        data?.leave_to_timetype,
        true
      )
      setLeaveDayAll(leaveDayAll);
    } else {
      leaveDays = calculateLeaveDays(
        data?.leave_from_date,
        data?.leave_from_timetype,
        data.leave_to_date,
        data?.leave_to_timetype
      )
    }
    const leaveRestOrAbsenceDays = calculateLeaveDays(
      data?.leave_from_date,
      data?.leave_from_timetype,
      data.leave_to_date,
      data?.leave_to_timetype
    );

    if (configForm?.form_type === 3) {
      setData((prev) => ({
        ...prev,
        leave_days: leaveDays,
        leave_rest_day: leaveRestOrAbsenceDays,
      }));
    } else {
      setData((prev) => ({
        ...prev,
        leave_days: leaveDays,
      }));
    }

    setHideTimeTypeSelect(true)
    setAllDayCancel([]);
    setSelectDayCancel([]);
    if (configForm?.form_type === 2) {
      SetStartEndCancel(data.leave_from_date,data.leave_to_date);
      getAllDayCancel(data.leave_from_date,data.leave_to_date);
    }
  }, [data.leave_from_date,data.leave_to_date, data.leave_from_timetype, data.leave_to_timetype, data.leave_type_id])
  
  
  const [eventLeaveTo, setEventLeaveTo] = useState(null)
  const [eventLeaveForm, setEventLeaveForm] = useState(null)
  const [hideTimeTypeSelect, setHideTimeTypeSelect] = useState(true)

  useEffect(() => {
    if (eventLeaveForm !== null) {
      setLeaveFromDate(eventLeaveForm)
    }
    if (eventLeaveTo !== null) {
      setLeaveToDate(eventLeaveTo)
    }
    
  }, [eventLeaveTo,eventLeaveForm])

  useEffect(() => {
    if (configForm?.form_type !== 2) {
      setHideTimeTypeSelect(true)
    } else {
      if (selectDayCancel?.length > 0 ) {
        setHideTimeTypeSelect(false)
      }
    }
  }, [configForm?.form_type])
  
  const [alertSelect, setAlertSelect] = useState(false)

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const calculateNewCancelLeaveDay = ( leavefromType, leaveToType, leaveDays, eTarget ) => {
    if (leavefromType === "1" && leaveToType === "2") {
      if (eTarget === "0") {
        return leaveDays + 0;
      }
      if (eTarget === "1") {
        return leaveDays + 0.5;
      }
      if (eTarget === "2") {
        return leaveDays + 0.5;
      }
    } else if (leavefromType === "1" && leaveToType === "1") {
      if (eTarget === "0") {
        return leaveDays - 0.5;
      }
      if (eTarget === "1") {
        return leaveDays + 0;
      }
      if (eTarget === "2") {
        return leaveDays + 0;
      }
    } else if (leavefromType === "2" && leaveToType === "2") {
      if (eTarget === "0") {
        return leaveDays - 0.5;
      }
      if (eTarget === "1") {
        return leaveDays + 0;
      }
      if (eTarget === "2") {
        return leaveDays + 0;
      }
    }
  };

  const isWeekend = (date) => {
    const day = new Date(date)?.getDay();
    return day === 6 || day === 0;
  };

  const isThaiPublic = (date) => {
    const localDate = new Date(date)?.setHours(0, 0, 0, 0);
    return holiday.some((item) => {
        const startDate = new Date(item?.date_start_holiday)?.setHours(0, 0, 0, 0);
        const endDate = new Date(item?.date_end_holiday)?.setHours(0, 0, 0, 0);
        return (localDate >= startDate && localDate <= endDate);
      }
    );
  };

  const areDatesMatched = (dates, cancelDates) => {
    const dateTimestamps = new Set(dates.map(x => x.date.setHours(0, 0, 0, 0)));
    const matchedCancelDates = cancelDates.filter(cancelDate => dateTimestamps.has(cancelDate?.date_cancel?.setHours(0, 0, 0, 0)));
    return matchedCancelDates.length >= dates.length;
  }

  const updateStateAtIndex = (index, newValues, setState, setStateBoolean, boolValue) => {
    setStateBoolean(boolValue)
    setState(prevState => {
        const newState = [...prevState];
        newState[index] = { ...newState[index], ...newValues };
        return newState;
    });
  };

  const filterLFandLT = (genDateCancelFromToArray,dateCancel) =>{
    let dateCancelLTandLF = []
    let dataLFLT
    if (genDateCancelFromToArray.length == 1) {
      for (let index = 0; index < genDateCancelFromToArray.length; index++) {
        const element = genDateCancelFromToArray[index];
        let holidayWeekend = isWeekend(element);
        let holidayThaiPublic = isThaiPublic(element);
        if (!holidayWeekend && !holidayThaiPublic) {
          if (dateCancel?.leave_from_timetype === "1" && dateCancel?.leave_to_timetype === "1") {
            dataLFLT = {
              date: element,
              leave_from_timetype: "1",
              leave_to_timetype:  "1"
            }
            dateCancelLTandLF.push(dataLFLT)
          } else if (dateCancel?.leave_from_timetype === "2" && dateCancel?.leave_to_timetype === "2") {
            dataLFLT = {
              date: element,
              leave_from_timetype: "2",
              leave_to_timetype: "2",
            }
            dateCancelLTandLF.push(dataLFLT)
          } else if (dateCancel?.leave_from_timetype === "1" && dateCancel?.leave_to_timetype === "2") {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype:  "2"
              }
              dateCancelLTandLF.push(dataLFLT)
          } else if (dateCancel?.leave_from_timetype === "2" && dateCancel?.leave_to_timetype === "1") {
            dataLFLT = {
              date: element,
              leave_from_timetype: "2",
              leave_to_timetype:  "1"
            }
            dateCancelLTandLF.push(dataLFLT)
          }
        }
      }
    } else if (genDateCancelFromToArray.length == 2) {
      for (let index = 0; index < genDateCancelFromToArray.length; index++) {
        const element = genDateCancelFromToArray[index];
        let holidayWeekend = isWeekend(element);
        let holidayThaiPublic = isThaiPublic(element);
        if (!holidayWeekend && !holidayThaiPublic) {
          if (dateCancel?.leave_from_timetype === "1" && dateCancel?.leave_to_timetype === "1") {
            if (index == 0) {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype: "2",
              }
            } else {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype:  "1"
              }
            }
            dateCancelLTandLF.push(dataLFLT)
          } else if (dateCancel?.leave_from_timetype === "2" && dateCancel?.leave_to_timetype === "2") {
            if (index == 0) {
              dataLFLT = {
                date: element,
                leave_from_timetype: "2",
                leave_to_timetype: "2",
              }
            } else {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype:  "2"
              }
            }
            dateCancelLTandLF.push(dataLFLT)
          } else if (dateCancel?.leave_from_timetype === "1" && dateCancel?.leave_to_timetype === "2") {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype:  "2"
              }
              dateCancelLTandLF.push(dataLFLT)
          } else if (dateCancel?.leave_from_timetype === "2" && dateCancel?.leave_to_timetype === "1") {
            if (index == 0) {
              dataLFLT = {
                date: element,
                leave_from_timetype: "2",
                leave_to_timetype: "2",
              }
            } else {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype:  "1"
              }
            }
            dateCancelLTandLF.push(dataLFLT)
          }
        }
      }
    } else if (genDateCancelFromToArray.length > 2) {
      for (let index = 0; index < genDateCancelFromToArray.length; index++) {
        const element = genDateCancelFromToArray[index];
        let holidayWeekend = isWeekend(element);
        let holidayThaiPublic = isThaiPublic(element);
        if (!holidayWeekend && !holidayThaiPublic) {
          if (dateCancel?.leave_from_timetype === "1" && dateCancel?.leave_to_timetype === "1") {
            if (index == 0) {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype: "2",
              }
            } else if (index > 0 && index < (genDateCancelFromToArray.length - 1)) {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype: "2",
              }
            } else {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype:  "1"
              }
            }
            dateCancelLTandLF.push(dataLFLT)
          } else if (dateCancel?.leave_from_timetype === "2" && dateCancel?.leave_to_timetype === "2") {
            if (index == 0) {
              dataLFLT = {
                date: element,
                leave_from_timetype: "2",
                leave_to_timetype: "2",
              }
            } else if (index > 0 && index < (genDateCancelFromToArray.length - 1)) {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype: "2",
              }
            } else {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype:  "2"
              }
            }
            dateCancelLTandLF.push(dataLFLT)
          } else if (dateCancel?.leave_from_timetype === "1" && dateCancel?.leave_to_timetype === "2") {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype:  "2"
              }
              dateCancelLTandLF.push(dataLFLT)
          } else if (dateCancel?.leave_from_timetype === "2" && dateCancel?.leave_to_timetype === "1") {
            if (index == 0) {
              dataLFLT = {
                date: element,
                leave_from_timetype: "2",
                leave_to_timetype: "2",
              }
            } else if (index > 0 && index < (genDateCancelFromToArray.length - 1)) {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype: "2",
              }
            } else {
              dataLFLT = {
                date: element,
                leave_from_timetype: "1",
                leave_to_timetype:  "1"
              }
            }
            dateCancelLTandLF.push(dataLFLT)
          }
        }
      }
    }
    return dateCancelLTandLF
  }

  const checkLeaveDateCancel = async (leave_data_id) =>{
    let params = new URLSearchParams({
      page : 1,
      size : 100,
      "order[0]": "id_leave_date_list",
      "order[1]": "DESC",
      "filter[leave_data_id][0]": leave_data_id,
    })
    const response = await FetchAxiosGet('/api/leave/cancel/list/datatable', token, params)
    if (response?.result?.length > 0) {
      response?.result.map(iTem => {
        setLeaveDataCanCelDateDataTable((prev) => [...prev.filter(x => x.id_leave_date_list !== iTem.id_leave_date_list), iTem])
      })
    } else {
      return false
    }
  }

  useEffect(() => {
    if (selectDayCancel?.length > 0 && leaveDataFromSelect?.length > 0 && checkRangeLeaveDataFromSelectBool) {
      
      let dateCancelLTandLF = []
      
      leaveDataFromSelect.forEach(dateCancel => {
        let checkCancelDateDay = leaveDataCanCelDateDataTable.filter(x => x.leave_data_id == dateCancel?.leave_data_id)
        if (checkCancelDateDay.length > 0) {
          let dates = generateDateArray(dateCancel?.leave_from_date, dateCancel?.leave_to_date)
          const cancelTimestamps = new Set(checkCancelDateDay.map(item => new Date(item.date_cancel).setHours(0, 0, 0, 0)));
          const filteredDates = dates.filter(date => !cancelTimestamps.has(date.setHours(0, 0, 0, 0)));
          dateCancelLTandLF.push(filterLFandLT(filteredDates,dateCancel)) 
        } else {
          let dates = generateDateArray(dateCancel?.leave_from_date, dateCancel?.leave_to_date)
          dateCancelLTandLF.push(filterLFandLT(dates,dateCancel))
        }
        dateCancelLTandLF = dateCancelLTandLF.flat()
      });
      
      let genFromToArray = generateDateArray(data?.leave_from_date,data?.leave_to_date)
      const dateSet = new Set(genFromToArray.map(date => date.toDateString()));
      let dateCancelLTandLFArray = dateCancelLTandLF?.filter(date => dateSet.has(new Date(date.date).toDateString()))
      dateCancelLTandLFArray = dateCancelLTandLFArray.sort((a, b) => a.date - b.date)

      dateCancelLTandLFArray.forEach(element => {
        let allDayIDX = selectDayCancel?.findIndex( y => new Date(y?.date_cancel)?.setHours(0, 0, 0, 0) === new Date(element.date)?.setHours(0, 0, 0, 0))
        
        let valueDefault = selectDayCancel?.find( y => new Date(y?.date_cancel)?.setHours(0, 0, 0, 0) === new Date(element.date)?.setHours(0, 0, 0, 0))
        if (allDayIDX !== -1) {
          updateStateAtIndex(
            allDayIDX, 
            { 
              check: true, 
              leave_from_timetype: element?.leave_from_timetype, 
              leave_to_timetype: element?.leave_to_timetype 
            }, 
            setSelectDayCancel, 
            setCheckRangeLeaveDataFromSelectBool, 
            false
          );
          const sumDay = calculateNewCancelLeaveDay(
            valueDefault?.leave_from_timetype,
            valueDefault?.leave_to_timetype,
            data?.leave_days,
            element?.leave_from_timetype === "1" && element?.leave_to_timetype === "1" ? "1" 
            : element?.leave_from_timetype === "2" && element?.leave_to_timetype === "2" ? "2" 
            : element?.leave_from_timetype === "1" && element?.leave_to_timetype === "2" ? "0"
            : element?.leave_from_timetype === "2" && element?.leave_to_timetype === "1" && "0" ,
          );
          setData((prev) => ({ ...prev, leave_days: sumDay }));
        }
      });

      if (selectDayCancel.length >= dateCancelLTandLFArray.length && areDatesMatched(dateCancelLTandLFArray,selectDayCancel)) {
        setCheckLeaveDataFromSelect(false)
      } else {
        setCheckLeaveDataFromSelect(true)
      }

    }
    if (selectDayCancel.length == 0) {
      setCheckLeaveDataFromSelect(true)
    }
  }, [selectDayCancel])

  useEffect(() => {
    if (configForm?.form_type === 3) {
      getLeavePerson(data?.leave_from_date, data?.leave_to_date);
      getLeaveVacation(data?.leave_from_date, data?.leave_to_date);
    }
  }, [data?.leave_from_date, data?.leave_to_date])

  const [leaveConfigFlowData, setLeaveConfigFlowData] = useState({ thisFlow: [], lastUserApprove: {}, sendToFinal: false })

  useEffect(() => {
    const getLeaveConfigFlow = async () => {
      setFlowLoading(true)
      let flow = await leaveConfigFlow(token, baseURL, userInfo, data?.leave_type_id)
      setLeaveConfigFlowData(flow)
      setFlowLoading(false)
    }
    data?.leave_type_id && getLeaveConfigFlow()
  }, [data?.leave_type_id])

  return (
    <React.Fragment>
      <Modal
        size="md"
        centered
        isOpen={isLeaveDayZero}
        toggle={() => setAlertSelect(false)}
      >
        <ModalHeader toggle={() => setAlertSelect(false)}>
          แจ้งเตือน
        </ModalHeader>
        <ModalBody>
          <Container>
            <Row>
              <Col className="d-flex justify-content-center">
                <h3>มีการลาในวันที่เลือกอยู่แล้ว</h3>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
      <Modal
        size="md"
        centered
        isOpen={isLeaveDayZero}
        toggle={() => setIsLeaveDayZero(false)}
      >
        <ModalHeader toggle={() => setIsLeaveDayZero(false)}>
          แจ้งเตือน
        </ModalHeader>
        <ModalBody>
          <Container>
            <Row>
              <Col className="d-flex justify-content-center">
                <h3>จำนวนรวมของวันลาต้องไม่เท่ากับ 0</h3>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
      <Modal
        size="md"
        centered
        isOpen={reqRefLeaveDay}
        toggle={() => setReqRefLeaveDay(false)}
      >
        <ModalHeader toggle={() => setReqRefLeaveDay(false)}>
          แจ้งเตือน
        </ModalHeader>
        <ModalBody>
          <Container>
            <Row>
              <Col className="d-flex justify-content-center">
                <h5>วันลากิจหรือวันลาพักผ่อนรวมต้องไม่น้อยกว่าวันลาไปต่างประเทศ</h5>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
      {configForm?.form_type ? (
        flowLoading ? 
        (
          <FadeIn>
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: loadingBar.default,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              width={180}
              height={180}
            />
          </FadeIn>
        )
        :
        (<Form
          onSubmit={(e) => {
            e.preventDefault();
            formValidate?.handleSubmit();
            return false;
          }}
        >
          <FormGroup row className="mt-3">
            {configForm?.form_type === 7 && <Label className="text-end text-danger" xs={12} xxl={12} lg={12} md={12}>
              *ใช้ในกรณีลาไปอบรมในประเทศและต่างประเทศระยะยาว (มากกว่า 7 วันติดต่อกัน)
            </Label>}
            <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
              เขียนที่ :
            </Label>
            <Label xs={9} xxl={4}>{data?.writeFrom}</Label>
            <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
              วันที่เขียน :
            </Label>
            <Label xs={9} xxl={4}>
              {ConvertDate(data?.writeDate)?.toThaiDateDMY()}
            </Label>
            <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
              {configForm?.form_type === 7 && (
                <span className="me-1 text-danger">*</span>
              )}
              เรื่อง :
            </Label>
            {configForm.form_type === 7 ? (
              <>
              <Col xs={9} xl={6}>
                <Input required value={data?.leave_name} onChange={(e) => {
                  setData(prev => ({...prev, leave_name: e.target.value}))
                }} /> 
              </Col>
              <Col xs={12} xl={4}></Col>
              </>
            ) : (
              <Label xs={9} xxl={10}>
              {data?.leave_name}
            </Label>
            )}
            <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
              เรียน :
            </Label>
            <Label xs={9} xxl={10}>{data?.send_to.split('-')[0]}</Label>
            <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
            </Label>
            <Label xs={9} xxl={10}>{data?.send_to.split('-')[1]}</Label>
            <Label xs={3} className="text-end mt-2" xxl={2} lg={3} md={3}>
              ชื่อ :
            </Label>
            <Label xs={9} xxl={10} className=" mt-2">{data?.user_name}</Label>
            <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
              ตำแหน่ง :
            </Label>
            <Label xs={9} xxl={10}>{data?.user_position_name || "-"}</Label>
            <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
              สังกัด/กอง:
            </Label>
            <Label xs={9} xxl={10}>{data?.cont_to_name_1}</Label>
          </FormGroup>
          {configForm?.form_type === 1 && (
            <FormGroup row>
              <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
                <span className="me-1 text-danger">*</span>ขอลา
              </Label>

              <Col xs={9} xxl={3} lg={9} md={9}>
                <Input
                  type="select"
                  value={data?.leave_type_id}
                  onChange={(e) => {
                    setData((prev) => ({
                      ...prev,
                      leave_type_id: e.target.value,
                      leave_name: `ขอ${
                        e.target.options[e.target.selectedIndex].text
                      }`,
                    }));
                  }}
                >
                  {configForm?.leave_type?.map((item) => {
                    return (
                      <option
                        key={item?.leave_type_id}
                        value={item?.leave_type_id}
                      >
                        {item?.leave_name}
                      </option>
                    );
                  })}
                </Input>
              </Col>
            </FormGroup>
          )}
          {configForm?.form_type === 2 && data.budget_year === CheckBudgetYear() && (
            <>
              <FormGroup row className="text-end">

                <Label xs={11} xxl={11}>
                {"วันลาพักผ่อนสะสมยกมา "}
                  <strong className="text-primary font-size-16">
                    {vacationRemain?.vacationDayPrev}
                  </strong>{" วัน"}
                </Label>

                <Label xs={11} xxl={11}>
                  {"ใช้ไป "}
                  <strong className="text-primary font-size-16">
                    {vacationRemain?.vacationUse}
                  </strong>{" วัน"}
                </Label>

                <Label xs={11} xxl={11}>
                  {"วันลาพักผ่อนคงเหลือ "}
                  <strong className="text-primary font-size-16">
                    {vacationRemain?.vacationRemaining}
                  </strong>
                  {" วัน"}
                </Label>

              </FormGroup>
            </>
          )}
          {configForm?.form_type === 3 && (
            <>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  มีความประสงค์จะลา
                </Label>
                <Col xs={9} xl={4}>
                  <Input disabled type="text" value="ไปต่างประเทศ" />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>เพื่อไป
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    name="abroad_for"
                    type="text"
                    onBlur={formValidate?.handleBlur}
                    onChange={(e) => {
                      formValidate?.handleChange(e);
                      handleInputChange(e, "abroad_for");
                    }}
                    value={formValidate?.values.abroad_for}
                    invalid={
                      formValidate?.touched?.abroad_for &&
                      formValidate?.errors?.abroad_for
                        ? true
                        : false
                    }
                  />
                  {formValidate?.touched?.abroad_for &&
                  formValidate?.errors?.abroad_for ? (
                    <FormFeedback type="invalid">
                      {formValidate?.errors?.abroad_for}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>ณ ประเทศ
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    name="abroad_country"
                    onBlur={formValidate?.handleBlur}
                    onChange={(e) => {
                      formValidate?.handleChange(e);
                      handleInputChange(e, "abroad_country");
                    }}
                    value={formValidate?.values?.abroad_country}
                    type="text"
                    invalid={
                      formValidate?.touched?.abroad_country &&
                      formValidate?.errors?.abroad_country
                        ? true
                        : false
                    }
                  />
                  {formValidate?.touched?.abroad_country &&
                  formValidate?.errors?.abroad_country ? (
                    <FormFeedback type="invalid">
                      {formValidate?.errors?.abroad_country}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
            </>
          )}
          {configForm?.form_type === 4 && (
            <>
              <FormGroup row>
                <Col xs={2} md={2} xl={3}></Col>
                <Col xs={9} md={9} xl={8}>
                  <Row>
                    <Col xs={2} md={2} xl={1}>
                      <Input
                        name="ordinate_ever"
                        type="radio"
                        className="font-size-18 border border-secondary mt-auto"
                        onChange={(e) =>
                          setData((prev) => ({
                            ...prev,
                            ordinate_ever: 0,
                          }))
                        }
                      />
                    </Col>
                    <Col xs={10} md={10} xxl={4}>
                      <Label check>ยังไม่เคยอุปสมบท</Label>
                    </Col>
                    <Col xs={2} md={2} xl={1}>
                      <Input
                        name="ordinate_ever"
                        type="radio"
                        className="font-size-18 border border-secondary mt-auto"
                        onChange={(e) =>
                          setData((prev) => ({
                            ...prev,
                            ordinate_ever: 1,
                          }))
                        }
                      />
                    </Col>
                    <Col xs={10} md={10} xxl={4}>
                      <Label check>เคยอุปสมบท</Label>
                    </Col>
                  </Row>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={4} xxl={3} style={{whiteSpace: "nowrap"}}>
                  <span className="me-1 text-danger">*</span>จะอุปสมบท ณ วัด
                </Label>
                <Col xs={8} xl={4}>
                  <Input
                    name="ordinate_temple"
                    type="text"
                    onBlur={formValidate?.handleBlur}
                    onChange={(e) => {
                      formValidate.handleChange(e);
                      handleInputChange(e, "ordinate_temple");
                    }}
                    value={data?.ordinate_temple}
                    invalid={
                      formValidate?.touched?.ordinate_temple &&
                      formValidate?.errors?.ordinate_temple
                        ? true
                        : false
                    }
                  />
                  {formValidate?.touched?.ordinate_temple &&
                  formValidate?.errors?.ordinate_temple ? (
                    <FormFeedback>
                      {formValidate?.errors?.ordinate_temple}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>ตั้งอยู่ ณ
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    name="ordinate_temple_place"
                    onBlur={formValidate?.handleBlur}
                    onChange={(e) => {
                      handleInputChange(e, "ordinate_temple_place");
                      formValidate?.handleChange(e);
                    }}
                    value={data?.ordinate_temple_place}
                    type="text"
                    invalid={
                      formValidate?.touched?.ordinate_temple_place &&
                      formValidate?.errors?.ordinate_temple_place
                        ? true
                        : false
                    }
                  />
                  {formValidate?.touched?.ordinate_temple_place &&
                  formValidate?.errors?.ordinate_temple_place ? (
                    <FormFeedback>
                      {formValidate?.errors?.ordinate_temple_place}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Label className="text-end" xs={3} xl={2}>
                  <span className="me-1 text-danger">*</span>วันที่อุปสมบท
                </Label>
                <Col xs={9} xl={3} className={`${windowSize.width < 1200 ? "mt-2" : ""}`}>
                  {/* <Flatpickr
                    name="ordinate_date"
                    className="form-control d-block"
                    placeholder="วัน/เดือน/ปี"
                    options={{
                      dateFormat: "d-m-Y",
                      ariaDateFormat: "F j, Y",
                      locale: "th",
                    }}
                    value={data?.ordinate_date}
                    onChange={(e) => {
                      setData((prev) => ({ ...prev, ordinate_date: e[0] }));
                    }}
                  /> */}
                  <NewThaiDatePicker name ={"ordinate_date"} value={data?.ordinate_date} setValue={setOrdinateDate} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี"/>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>จำพรรษา ณ วัด
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    name="ordinate_live_temple"
                    onBlur={formValidate?.handleBlur}
                    onChange={(e) => {
                      handleInputChange(e, "ordinate_live_temple");
                      formValidate.handleChange(e);
                    }}
                    value={data?.ordinate_live_temple}
                    type="text"
                    invalid={
                      formValidate?.touched?.ordinate_live_temple &&
                      formValidate?.errors?.ordinate_live_temple
                        ? true
                        : false
                    }
                  />
                  {formValidate?.touched?.ordinate_live_temple &&
                  formValidate?.errors?.ordinate_live_temple ? (
                    <FormFeedback>
                      {formValidate?.errors?.ordinate_live_temple}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>ตั้งอยู่ ณ
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    name="ordinate_live_place"
                    onBlur={formValidate?.handleBlur}
                    onChange={(e) => {
                      handleInputChange(e, "ordinate_live_place");
                      formValidate?.handleChange(e);
                    }}
                    value={formValidate?.values?.ordinate_live_place}
                    type="text"
                    invalid={
                      formValidate?.touched?.ordinate_live_place &&
                      formValidate?.errors?.ordinate_live_place
                        ? true
                        : false
                    }
                  />
                  {formValidate?.touched?.ordinate_live_place &&
                  formValidate?.errors?.ordinate_live_place ? (
                    <FormFeedback>
                      {formValidate?.errors?.ordinate_live_place}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
            </>
          )}
          {configForm?.form_type === 5 && (
            <FormGroup row>
              <Col xs={3} xl={3}></Col>
              <Col xs={9} xl={8}>
                <Row>
                  <Col xs={2} xl={1}>
                    <Input
                      required
                      name="hujj_ever"
                      type="radio"
                      className="font-size-18 border border-secondary mt-auto"
                      onChange={(e) => {
                        setData((prev) => ({
                          ...prev,
                          hujj_ever: "0",
                        }));
                      }}
                    />
                  </Col>
                  <Col xs={10} xl={5}>
                    <Label check>ยังไม่เคยไปประกอบพิธีฮัจญ์ </Label>
                  </Col>
                  <Col xs={2} xl={1}>
                    <Input
                      required
                      name="hujj_ever"
                      type="radio"
                      className="font-size-18 border border-secondary mt-auto"
                      onChange={(e) =>
                        setData((prev) => ({
                          ...prev,
                          hujj_ever: "1",
                        }))
                      }
                    />
                  </Col>
                  <Col xs={10} xl={5}>
                    <Label check>เคยไปประกอบพิธีฮัจญ์</Label>
                  </Col>
                </Row>
              </Col>
            </FormGroup>
          )}
          {configForm?.form_type === 6 && (
            <>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>ได้รับหมายเรียกของ
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    name="conscription_from"
                    value={data.conscription_from}
                    type="text"
                    onBlur={formValidate.handleBlur}
                    onChange={(e) => {
                      handleInputChange(e, "conscription_from");
                      formValidate.handleChange(e);
                    }}
                    invalid={
                      formValidate.touched.conscription_for &&
                      formValidate.errors.conscription_from
                        ? true
                        : false
                    }
                  />
                  {formValidate.touched.conscription_for &&
                  formValidate.errors.conscription_from ? (
                    <FormFeedback>
                      {formValidate.errors.conscription_for}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>ที่
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    name="conscription_place"
                    type="text"
                    value={data.conscription_place}
                    onBlur={formValidate.handleBlur}
                    onChange={(e) => {
                      formValidate.handleChange(e);
                      handleInputChange(e, "conscription_place");
                    }}
                    invalid={
                      formValidate.touched.conscription_place &&
                      formValidate.errors.conscription_place
                        ? true
                        : false
                    }
                  />
                  {formValidate.touched.conscription_place &&
                  formValidate.errors.conscription_place ? (
                    <FormFeedback>
                      {formValidate.errors.conscription_place}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Label className="text-end" xs={3} xxl={2}>
                  <span className="me-1 text-danger">*</span>ลงวันที่
                </Label>
                <Col xs={9} xl={3} className={`${windowSize.width < 1200 ? "mt-2" : ""}`}>
                  {/* <Flatpickr
                    required
                    name="conscription_date"
                    className="form-control d-block"
                    placeholder="วัน/เดือน/ปี"
                    options={{
                      // altInput: true,
                      dateFormat: "d-m-Y",
                      ariaDateFormat: "F j, Y",
                      locale: "th",
                    }}
                    value={data?.conscription_date}
                    onChange={(e) => {
                      setData((prev) => ({ ...prev, conscription_date: e[0] }));
                    }}
                  /> */}
                  <NewThaiDatePicker name={"conscription_date"} value={data?.conscription_date} setValue={setConscriptionDate} placeholderText = "วัน/เดือน/ปี"/>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>ให้เข้ารับการ
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    name="conscription_for"
                    type="text"
                    value={data.conscription_for}
                    onBlur={formValidate.handleBlur}
                    onChange={(e) => {
                      formValidate.handleChange(e);
                      handleInputChange(e, "conscription_for");
                    }}
                    invalid={
                      formValidate.touched.conscription_for &&
                      formValidate.errors.conscription_for
                        ? true
                        : false
                    }
                  />
                  {formValidate.touched.conscription_for &&
                  formValidate.errors.conscription_for ? (
                    <FormFeedback>
                      {formValidate.errors.conscription_for}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>ณ ที่
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    name="conscription_to_place"
                    value={data.conscription_to_place}
                    type="text"
                    onBlur={formValidate.handleBlur}
                    onChange={(e) => {
                      handleInputChange(e, "conscription_to_place");
                      formValidate.handleChange(e);
                    }}
                    invalid={
                      formValidate.touched.conscription_to_place &&
                      formValidate.errors.conscription_to_place
                        ? true
                        : false
                    }
                  />
                  {formValidate.touched.conscription_to_place &&
                  formValidate.errors.conscription_to_place ? (
                    <FormFeedback>
                      {formValidate.errors.conscription_to_place}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
            </>
          )}
          {configForm?.form_type === 7 && (
            <>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="text-danger pe-1">*</span> มีความประสงค์ 
                </Label>
                <Col xs={9} xl={8}>
                  <Input
                    name="abroad_for"
                    type="textarea"
                    style={{ height: "75px" }}
                    value={data?.abroad_for}
                    onBlur={formValidate?.handleBlur}
                    onChange={(e) => {
                      formValidate?.handleChange(e);
                      handleInputChange(e, "abroad_for")
                    }}
                    invalid={
                      formValidate?.touched.abroad_for &&
                      formValidate?.errors.abroad_for
                        ? true
                        : false
                    }
                  />
                  {formValidate?.touched?.abroad_for &&
                  formValidate?.errors?.abroad_for ? (
                    <FormFeedback>
                      {formValidate?.errors?.abroad_for}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>ณ ประเทศ
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    name="abroad_country"
                    type="text"
                    value={data.abroad_country}
                    onBlur={formValidate?.handleBlur}
                    onChange={(e) => {
                      formValidate?.handleChange(e);
                      handleInputChange(e, "abroad_country");
                    }}
                    invalid={
                      formValidate?.touched.abroad_country &&
                      formValidate?.errors.abroad_country
                        ? true
                        : false
                    }
                  />
                  {formValidate?.touched?.abroad_country &&
                  formValidate?.errors?.abroad_country ? (
                    <FormFeedback>
                      {formValidate?.errors?.abroad_country}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  ด้วยทุน(ถ้ามี)
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    type="text"
                    value={data?.training_fund_from}
                    onChange={(e) => handleInputChange(e, "training_fund_from")}
                  />
                </Col>
              </FormGroup>
            </>
          )}
          {configForm?.form_type === 8 && (
            <FormGroup row>
              <Label className="text-end" xs={3} xxl={3}>
                <span className="me-1 text-danger">*</span>มีความประสงค์จะลา
              </Label>
              <Col xs={9} xl={4}>
                <Input
                  type="text"
                  readOnly
                  disabled
                  value="ติดตามคู่สมรส"
                  onChange={(e) => handleInputChange(e, "leaveReq")}
                />
              </Col>
            </FormGroup>
          )}
          {configForm?.form_type === 9 && (
            <FormGroup row>
              <Label className="text-end" xs={3} xxl={3}>
                <span className="me-1 text-danger">*</span>สถานที่
              </Label>
              <Col xs={9} xl={8}>
                <Input
                  name="outside_place"
                  type="text"
                  value={data.outside_place}
                  onBlur={formValidate?.handleBlur}
                  onChange={(e) => {
                    handleInputChange(e, "outside_place");
                    formValidate.handleChange(e);
                  }}
                  invalid={
                    formValidate?.touched?.outside_place &&
                    formValidate?.errors?.outside_place
                      ? true
                      : false
                  }
                />
                {formValidate?.touched?.outside_place &&
                formValidate?.errors?.outside_place ? (
                  <FormFeedback>
                    {formValidate?.errors?.outside_place}
                  </FormFeedback>
                ) : null}
              </Col>
            </FormGroup>
          )}
          {configForm?.form_type === 11 && (
            <FormGroup row>
              <Label className="text-end" xs={3} xxl={3}>
                มีความประสงค์จะลา
              </Label>
              <Col xs={9} xxl={8}>
                <Input
                  type="select"
                  value={data?.leave_type_id}
                  onChange={(e) => {
                    setData((prev) => ({
                      ...prev,
                      leave_type_id: e.target.value,
                      leave_name: `${
                        e.target.options[e.target.selectedIndex].text
                      }`,
                    }));
                  }}
                >
                  {configForm?.leave_type?.map((item, idx) => {
                    return (
                      <option
                        key={item?.leave_type_id}
                        value={item?.leave_type_id}
                      >
                        {item?.leave_name}
                      </option>
                    );
                  })}
                </Input>
              </Col>
            </FormGroup>
          )}
          {configForm?.form_type === 1 || configForm?.form_type === 11 ? (
            <FormGroup row>
              <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
                <span className="me-1 text-danger">*</span>เนื่องจาก
              </Label>
              <Col xs={9} xxl={8} lg={9} md={9}>
                <Input
                  className="form-control"
                  type="textarea"
                  name="leave_reason"
                  onChange={(e) => {
                    formValidate?.handleChange(e);
                    handleInputChange(e, "leave_reason");
                  }}
                  onBlur={formValidate?.handleBlur}
                  value={formValidate?.values?.leave_reason}
                  style={{ height: "75px" }}
                  invalid={
                    formValidate?.touched?.leave_reason &&
                    formValidate?.errors?.leave_reason
                      ? true
                      : false
                  }
                />
                {formValidate?.touched?.leave_reason &&
                formValidate?.errors?.leave_reason ? (
                  <FormFeedback>
                    {formValidate?.errors?.leave_reason}
                  </FormFeedback>
                ) : null}
              </Col>
            </FormGroup>
          ) : null}

          <FormGroup row>
            <Label
              className="text-end mt-2"
              xxl={configForm?.form_type === 10 ? 4 : 3}
              xs={3}
              lg={3}
              md={3}
            >
              <span className="me-1 text-danger">*</span>
              {configForm?.form_type === 10
                ? "ไม่สามารถลงปฏิบัติราชการเมื่อวันที่"
                : "ตั้งแต่วันที่"}
            </Label>
            <Col xs={9} xxl={3} lg={9} md={9} className="mt-2">
            <NewThaiDatePicker name={"leave_from_date"} value={data?.leave_from_date} setValue={setEventLeaveForm} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี" />
            </Col>
            {configForm?.form_type !== 4 && configForm?.form_type !== 8 && hideTimeTypeSelect === true ? (
              <>
                <Label
                  className="mt-2"
                  style={{ textAlign: "end" }}
                  xs={3}
                  xxl={2}
                  lg={3}
                  md={3}
                >
                  ช่วงเวลา
                </Label>
                <Col xs={9} xl={3} lg={9} md={9} className="mt-2">
                  <Input
                    type="select"
                    value={data?.leave_from_timetype}
                    onChange={(e) => {
                      if (data?.leave_from_date && data?.leave_to_date) {
                        const leaveDays = calculateLeaveDays(
                          new Date(
                            new Date(data?.leave_from_date).setHours(0, 0, 0, 0)
                          ),
                          e?.target?.value,
                          new Date(
                            new Date(data?.leave_to_date).setHours(0, 0, 0, 0)
                          ),
                          data?.leave_to_timetype
                        );
                        setData((prev) => ({
                          ...prev,
                          leave_from_timetype: e?.target?.value,
                          leave_days: leaveDays,
                          // leave_days: leaveDays - selectDayCancel?.length,
                        }));
                      }
                      setData((prev) => ({
                        ...prev,
                        leave_from_timetype: e?.target?.value,
                      }));
                    }}
                  >
                    <option value="1">9.30</option>
                    <option value="2">13.00</option>
                  </Input>
                </Col>
              </>
            ) : null}
          </FormGroup>
          {
          // configForm?.form_type !== 10 &&
          configForm?.form_type &&
            <FormGroup row>
              <Label
                className="text-end mt-2"
                xxl={configForm?.form_type === 10 ? 4 : 3}
                xs={3}
                lg={3}
                md={3}
              >
                <span className="me-1 text-danger">*</span>ถึงวันที่
              </Label>
              <Col xs={9} xl={3} lg={9} md={9} className="mt-2">
                <NewThaiDatePicker name={"leave_to_date"} value={data?.leave_to_date} setValue={setEventLeaveTo} minDate={data?.leave_from_date} maxDate={configForm?.form_type === 10 ? data?.leave_from_date : null} disabled={configForm?.form_type === 10}  returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี" />
              </Col>
              {configForm?.form_type !== 4 && configForm?.form_type !== 8 &&  hideTimeTypeSelect === true ? (
                <>
                  <Label
                    style={{ textAlign: "end" }}
                    xs={3}
                    xl={2}
                    lg={3}
                    md={3}
                    className="mt-2"
                  >
                    ช่วงเวลา
                  </Label>
                  <Col xs={9} xl={3} lg={9} md={9} className="mt-2">
                    <Input
                      type="select"
                      value={data?.leave_to_timetype}
                      onChange={(e) => {
                        if (data?.leave_from_date && data?.leave_to_date) {
                          const leaveDays = calculateLeaveDays(
                            new Date(
                              new Date(data?.leave_from_date).setHours(0, 0, 0, 0)
                            ),
                            data?.leave_from_timetype,
                            new Date(
                              new Date(data?.leave_to_date).setHours(0, 0, 0, 0)
                            ),
                            e?.target?.value
                          );

                          setData((prev) => ({
                            ...prev,
                            leave_to_timetype: e?.target?.value,
                            leave_days: leaveDays,
                          }));
                        }
                        setData((prev) => ({
                          ...prev,
                          leave_to_timetype: e?.target?.value,
                        }));
                      }}
                    >
                      <option value="1">12.00</option>
                      <option value="2">17.30</option>
                    </Input>
                  </Col>
                </>
              ) : null}
            </FormGroup>
          }
          {configForm?.form_type !== 3 && leaveDataFromSelect.length !== 0 && checkLeaveDataFromSelect ? (
            <FormGroup row>
              <Label className="text-end text-danger" xs={3} xxl={3} lg={3} md={3}>
               คุณมีการลาในช่วงวันที่เลือก
              </Label>
              <Col xs={9} xxl={8} lg={9} md={9}>
                {leaveDataFromSelect?.map((item, idx) => {
                return (
                  <Input
                    disabled key={idx}
                    style={{ textAlign: "start" }} 
                    className="text-danger mb-1"
                    value={
                      `${item?.leave_name} วันที่ ${ConvertDate(item.leave_from_date).toOnlyDateTHYear()} เวลา ${item?.leave_from_timetype === "1" ? "9.30" : "13.00"} น. ถึง ${
                        ConvertDate(item.leave_to_date).toOnlyDateTHYear()} เวลา ${item?.leave_to_timetype === "1" ? "12.00" : "17.30"} น.`
                    }
                  />
                );
                })}
              </Col>
            </FormGroup>
          ) : null}
          {configForm?.form_type === 2 && (
            <>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  ยกเว้นวันที่
                </Label>
                <Col xs={9} xxl={3}>
                  <Input
                    type="select"
                    value=""
                    onChange={(e) => {
                      const selectedDate = new Date(e.target.value);
                      setHideTimeTypeSelect(false)
                      if (
                        e.target.value !== "" &&
                        selectDayCancel?.length === 0
                      ) {
                        let newValue = {
                          leave_data_id: data?.leave_data_id || "",
                          date_cancel: selectedDate,
                          leave_from_timetype: "1",
                          leave_to_timetype: "2",
                        };

                        setData((prev) => ({
                          ...prev,
                          leave_days: prev.leave_days - 1,
                        }));
                        setSelectDayCancel((prev) => [...prev, newValue]);
                        setCheckRangeLeaveDataFromSelectBool(true)
                        setAllDayCancel((prev) =>
                          prev.filter(
                            (item) =>
                              new Date(
                                item?.date_cancel
                              )?.toLocaleDateString() !==
                              selectedDate?.toLocaleDateString()
                          )
                        );
                      } else if (
                        !selectDayCancel?.find(
                          (i) =>
                            new Date(i?.date_cancel)?.toLocaleDateString() ===
                            selectedDate.toLocaleDateString()
                        )
                      ) {
                        let check = selectDayCancel?.find(
                          (i) =>
                            new Date(i?.date_cancel)?.toLocaleDateString() ===
                            selectedDate.toLocaleDateString()
                        );

                        let newValue = {
                          leave_data_id: data?.leave_data_id,
                          date_cancel: selectedDate,
                          leave_from_timetype: "1",
                          leave_to_timetype: "2",
                        };

                        setData((prev) => ({
                          ...prev,
                          leave_days: prev.leave_days - 1,
                        }));
                        setCheckRangeLeaveDataFromSelectBool(true)
                        setSelectDayCancel((prev) => [...prev, newValue]);
                        setAllDayCancel((prev) =>
                          prev.filter(
                            (item) =>
                              new Date(
                                item?.date_cancel
                              )?.toLocaleDateString() !==
                              selectedDate?.toLocaleDateString()
                          )
                        );
                      }
                    }}
                  >
                    <option value="">เลือกวันที่ต้องการยกเลิก</option>
                    {allDayCancel &&
                      allDayCancel?.map((item, idx) => {
                        // let checkItem = CheckCancelDayIsweekEndOrThaiPublic(item?.date)
                        let checkAllWithSelectDay = selectDayCancel?.find(
                          (a) =>
                            new Date(a?.date_cancel)?.toLocaleDateString() ===
                            new Date(item?.date_cancel)?.toLocaleDateString()
                        );
                        let showDate = ConvertDate(
                          new Date(item?.date_cancel)
                        )?.toThaiDateDMY();
                        if (!checkAllWithSelectDay) {
                          return (
                            <option
                              key={idx}
                              value={new Date(item?.date_cancel)}
                            >
                              {showDate}
                            </option>
                          );
                        } else {
                          return null;
                        }
                      })}
                  </Input>
                </Col>
              </FormGroup>
              {selectDayCancel?.length === 0 ? null : (
                <FormGroup row className="d-flex align-items-center">
                  {selectDayCancel?.map((item, idx) => {
                    const DateItem = new Date(item?.date_cancel);
                    let showDate = ConvertDate(
                      item?.date_cancel
                    )?.toThaiDateDMY();
                    return (
                      <React.Fragment key={idx}>
                        <Label className="text-end" xs={3} xxl={4}>
                          <i
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              const selectedDate = new Date(item?.date_cancel);
                              if (selectDayCancel?.length === 1 ) {
                                setHideTimeTypeSelect(true)
                              }
                              let newValue = {
                                date_cancel: selectedDate,
                              };
                              if (
                                item?.leave_from_timetype === "1" &&
                                item?.leave_to_timetype === "1"
                              ) {
                                setData((prev) => ({
                                  ...prev,
                                  leave_days: prev?.leave_days + 0.5,
                                }));
                              }
                              if (
                                item?.leave_from_timetype === "2" &&
                                item?.leave_to_timetype === "2"
                              ) {
                                setData((prev) => ({
                                  ...prev,
                                  leave_days: prev?.leave_days + 0.5,
                                }));
                              }
                              if (
                                item?.leave_from_timetype === "1" &&
                                item?.leave_to_timetype === "2"
                              ) {
                                setData((prev) => ({
                                  ...prev,
                                  leave_days: prev?.leave_days + 1,
                                }));
                              }
                              if (
                                item?.leave_from_timetype === "2" &&
                                item?.leave_to_timetype === "1"
                              ) {
                                setData((prev) => ({
                                  ...prev,
                                  leave_days: prev?.leave_days + 1,
                                }));
                              }
                              setCheckRangeLeaveDataFromSelectBool(true)
                              setSelectDayCancel((prev) =>
                                prev.filter(
                                  (item) =>
                                    new Date(
                                      item?.date_cancel
                                    )?.toLocaleDateString() !==
                                    selectedDate.toLocaleDateString()
                                )
                              );
                              setAllDayCancel((prev) => [...prev, newValue]);
                            }}
                            className="fa-solid fa-circle-xmark font-size-18 me-2 text-danger"
                          ></i>
                          {showDate}
                        </Label>
                        <Label style={{ textAlign: "end" }} xs={3} xl={2} lg={3}>
                          ช่วงเวลา
                        </Label>
                        <Col xs={9} xl={3} lg={9} md={9} className="mt-2">
                          <Input
                            type="select"
                            value={
                                    item?.leave_from_timetype === "1" && item?.leave_to_timetype === "1" ? "1" 
                                    : item?.leave_from_timetype === "2" && item?.leave_to_timetype === "2" ? "2" 
                                    : item?.leave_from_timetype === "1" && item?.leave_to_timetype === "2" ? "0" 
                                    : item?.leave_from_timetype === "2" && item?.leave_to_timetype === "1" && "0" 
                            }
                            disabled={item?.check !== undefined ? item?.check : false}
                            onChange={(e) => {
                              const selectedTime = e.target.value;
                              const sumDay = calculateCancelLeaveDay(
                                item?.leave_from_timetype,
                                item?.leave_to_timetype,
                                data?.leave_days,
                                e.target.value,
                                DateItem
                              );
                              setData((prev) => ({
                                ...prev,
                                leave_days: sumDay,
                              }));
                            }}
                          >
                            <option value="0">เต็มวัน</option>
                            <option value="1">ครึ่งวันเช้า</option>
                            <option value="2">ครึ่งวันบ่าย</option>
                          </Input>
                        </Col>
                      </React.Fragment>
                    );
                  })}
                </FormGroup>
              )}
            </>
          )}
          {configForm?.form_type === 3 ? <FormGroup row style={{ display: "flex", alignItems: "center" }}>
            <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
              ไปต่างประเทศรวม
            </Label>
            <Col xs={9} xl={3} lg={9} md={9}>
              <Input
                disabled
                type="text"
                value={calculateLeaveDays(
                  data?.leave_from_date,
                  data?.leave_from_timetype,
                  data.leave_to_date,
                  data?.leave_to_timetype,
                  true,
                  true
                )}
                readOnly
              />
            </Col>
            <Label className="text-end" xs={3} xl={2} lg={3}>
              ใช้วันลารวม
            </Label>
            <Col xs={9} xl={3} lg={9} md={9}>
              <Input
                disabled
                type="text"
                value={data?.leave_days}
                readOnly
                onChange={(e) => {
                  handleInputChange(e, "leave_days");
                }}
              />
            </Col>
            <>
              <Label style={{ textAlign: "end" }} xs={3} xxl={3} lg={3} md={3}>
                ต้องลากิจหรือลาพักผ่อนรวมกัน
              </Label>
              <Col xs={9} xl={3} lg={9} md={9}>
                  <Input
                    className="mt-3"
                    disabled
                    type="text"
                    value={data?.leave_rest_day}
                    readOnly
                  />
                </Col>
              </>
          </FormGroup> : 
          <FormGroup row>
            <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
              รวม
            </Label>
            <Col xs={9} xxl={3} lg={3} md={3}>
              <Input
                disabled
                type="text"
                value={data?.leave_days}
                readOnly
                onChange={(e) => {
                  handleInputChange(e, "leave_days");
                }}
              />
              {formValidate.touched.contact_address &&
              formValidate.errors.contact_address ? (
                <FormFeedback>
                  {formValidate.errors.contact_address}
                </FormFeedback>
              ) : null}
            </Col>
          </FormGroup>
          }

          {configForm?.form_type !== 3 &&
            configForm?.form_type !== 4 &&
            configForm?.form_type !== 5 &&
            configForm?.form_type !== 6 &&
            configForm?.form_type !== 7 &&
            configForm?.form_type !== 8 &&
            configForm?.form_type !== 9 &&
            configForm?.form_type !== 10 &&
            configForm?.form_type !== 11 && (
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
                  <span className="me-1 text-danger">*</span>สถานที่ติดต่อ
                </Label>
                <Col xs={9} xxl={8} lg={9} md={9}>
                  <Input
                    name="contact_address"
                    className="form-control"
                    onBlur={formValidate.handleBlur}
                    onChange={formValidate.handleChange}
                    value={formValidate.values.contact_address}
                    style={{ height: "75px" }}
                    type="textarea"
                    invalid={
                      formValidate?.touched.contact_address &&
                      formValidate?.errors.contact_address
                        ? true
                        : false
                    }
                  />
                  {formValidate.touched.contact_address &&
                  formValidate.errors.contact_address ? (
                    <FormFeedback>
                      {formValidate.errors.contact_address}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
            )}
          {configForm?.form_type === 3 && (
            <FormGroup row style={{ display: "flex", alignItems: "center" }}>
              <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
                </Label>
              <Col xs={9} xxl={8} lg={9} md={9}>
                <Label >กรุณากรอก ลากิจ หรือ ลาพักผ่อน ก่อน</Label>
              </Col>
              <FormGroup/>
              <FormGroup row style={{ display: "flex", alignItems: "center" }}>
                <Label className="text-end"xs={3} xxl={3} lg={3} md={3}>
                  ได้ลากิจวันที่
                </Label>
                <Col xs={9} xl={3}>
                  <Input
                    type="select"
                    value={data.abroad_ref_2}
                    required={true}
                    invalid={!(data.abroad_ref_2 || data.abroad_ref) && !(data?.leave_rest_day === 0)}
                    onChange={(e) => handleInputChange(e, "abroad_ref_2")}
                  >
                    {leavePerson?.length === 0 ? (
                      <option>คุณไม่มีประวัติการลากิจ</option>
                    ) : (
                      <>
                        <option value="">กรุณาเลือกวันลากิจ</option>
                        {leavePerson?.map((item) => {
                          return (
                            <option value={item.leave_data_id}>
                              {item.leave_name}
                              &nbsp;วันที่{" "}
                              {convertDate(item.leave_from_date).toDate()}
                              &nbsp;{convertDate(item.leave_from_date).toMonth()}
                              &nbsp;{convertDate(item.leave_from_date).toYear()}
                              &nbsp;ถึง {convertDate(item.leave_to_date).toDate()}
                              &nbsp;{convertDate(item.leave_to_date).toMonth()}
                              &nbsp;{convertDate(item.leave_to_date).toYear()}
                              &nbsp;เป็นเวลา {item.leave_days} วัน
                            </option>
                          );
                        })}
                      </>
                    )}
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row style={{ display: "flex", alignItems: "center" }}>
                <Label className="text-end" xs={3} xl={3}>
                  ได้ลาพักผ่อนวันที่
                </Label>
                <Col xs={9} xl={3}>
                  <Input
                    type="select"
                    value={data.abroad_ref}
                    required={true}
                    invalid={userInfo?.user_trial === "1" ? false : !(data.abroad_ref_2 || data.abroad_ref) && !(data?.leave_rest_day === 0)}
                    onChange={(e) => handleInputChange(e, "abroad_ref")}
                  >
                    {leaveVacation?.length === 0 ? (
                      <option>คุณไม่มีประวัติการลาพักผ่อน</option>
                    ) : (
                      <>
                        <option value="">กรุณาเลือกวันลาพักผ่อน</option>
                        {leaveVacation?.map((item) => {
                          return (
                            <option value={item.leave_data_id}>
                              {item.leave_name}
                              &nbsp;วันที่{" "}
                              {convertDate(item.leave_from_date).toDate()}
                              &nbsp;{convertDate(item.leave_from_date).toMonth()}
                              &nbsp;{convertDate(item.leave_from_date).toYear()}
                              &nbsp;ถึง {convertDate(item.leave_to_date).toDate()}
                              &nbsp;{convertDate(item.leave_to_date).toMonth()}
                              &nbsp;{convertDate(item.leave_to_date).toYear()}
                              &nbsp;เป็นเวลา {item.leave_days} วัน
                            </option>
                          );
                        })}
                      </>
                    )}
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row style={{ display: "flex", alignItems: "center" }}>
                <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
                  รวม
                </Label>
                <Col xs={9} xl={3} lg={9} md={9}>
                  <Input
                    disabled
                    type="text"
                    invalid={data?.leave_rest_day > (leaveVacation.find((x) => x?.leave_data_id === data.abroad_ref)?.leave_days || 0) + (leavePerson.find((x) => x?.leave_data_id === data.abroad_ref_2)?.leave_days || 0)}
                    value={(leaveVacation.find((x) => x?.leave_data_id === data.abroad_ref)?.leave_days || 0) + (leavePerson.find((x) => x?.leave_data_id === data.abroad_ref_2)?.leave_days || 0)}
                    readOnly
                    // onChange={(e) => {
                    //   handleInputChange(e, "leave_days");
                    // }}
                  />
                </Col>
              </FormGroup>
            </FormGroup>
          )}
          {configForm?.form_type === 8 && (
            <>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>ชื่อคู่สมรส
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    name="spouse_name"
                    type="text"
                    value={data.spouse_name}
                    onChange={(e) => {
                      formValidate.handleChange(e);
                      handleInputChange(e, "spouse_name");
                    }}
                    onBlur={formValidate?.handleBlur}
                    invalid={
                      formValidate?.touched?.spouse_name &&
                      formValidate?.errors?.spouse_name
                        ? true
                        : false
                    }
                  />
                  {formValidate?.touched?.spouse_name &&
                  formValidate?.errors?.spouse_name ? (
                    <FormFeedback>
                      {formValidate?.errors?.spouse_name}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  ตำแหน่งคู่สมรส
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    type="text"
                    value={data?.spouse_position}
                    onChange={(e) => handleInputChange(e, "spouse_position")}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  สังกัดคู่สมรส
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    type="text"
                    value={data?.spouse_department}
                    onChange={(e) => handleInputChange(e, "spouse_department")}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>ปฏิบัติงาน ณ ประเทศ
                </Label>
                <Col xs={9} xl={4}>
                  <Input
                    name="spouse_country"
                    type="text"
                    value={data.spouse_country}
                    onBlur={formValidate?.handleBlur}
                    onChange={(e) => {
                      handleInputChange(e, "spouse_country");
                      formValidate?.handleChange(e);
                    }}
                    invalid={
                      formValidate?.touched?.spouse_country &&
                      formValidate?.errors?.spouse_country
                        ? true
                        : false
                    }
                  />
                  {formValidate?.touched?.spouse_country &&
                  formValidate?.errors?.spouse_country ? (
                    <FormFeedback>
                      {formValidate?.errors?.spouse_country}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>ตั้งแต่วันที่
                </Label>
                <Col xs={9} xxl={4}>
                  <NewThaiDatePicker name={"spouse_from_date"} value={data?.spouse_from_date} setValue={setSpouseFromDate} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี" />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>ถึงวันที่
                </Label>
                <Col xs={9} xxl={4}>
                  <NewThaiDatePicker name={"spouse_to_date"} value={data?.spouse_to_date} minDate = {data?.spouse_from_date} setValue={setSpouseToDate} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี" />
                </Col>
              </FormGroup>
            </>
          )}
          {configForm?.form_type === 10 && (
            <FormGroup row>
              <Label className="text-end" xs={3} xxl={3}>
                <span className="me-1 text-danger">*</span>เหตุผล
              </Label>
              <Col xs={9} xl={8}>
                <Input
                  name="practice_reason"
                  type="text"
                  value={data?.practice_reason}
                  onChange={(e) => {
                    formValidate.handleChange(e);
                    handleInputChange(e, "practice_reason");
                  }}
                  onBlur={formValidate.handleBlur}
                  invalid={
                    formValidate.touched.practice_reason &&
                    formValidate.errors.practice_reason
                      ? true
                      : false
                  }
                />
                {formValidate.touched.practice_reason &&
                formValidate.errors.practice_reason ? (
                  <FormFeedback>
                    {formValidate.errors.practice_reason}
                  </FormFeedback>
                ) : null}
              </Col>
            </FormGroup>
          )}
          <FormGroup row>
            <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
              หมายเหตุ
            </Label>
            <Col xs={9} xxl={8} lg={9} md={9}>
              <Input
                onChange={(e) => handleInputChange(e, "note")}
                value={data?.note || ""}
                style={{ height: "75px" }}
                type="textarea"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label className="text-end" xs={3} xxl={3} lg={3} md={4}>
              แนบเอกสาร{" "}
            </Label>
            <Col xs={9} xxl={8} lg={9} md={8}>
              <Row className="d-flex align-items-center">
                <Col>
                  <Input
                    key={fileKey}
                    // ref={fileInputRef}
                    type="file"
                    onChange={(e) => {
                      setData((prevData) => ({
                        ...prevData,
                        file_data: e?.target?.files[0],
                      }));
                    }}
                  />
                </Col>
                <Col>
                  <Button
                    onClick={() => {
                      setData((prev) => ({ ...prev, file_data: null }));
                      // fileInputRef.current.value = '';
                      setFileKey((prevKey) => prevKey + 1);
                    }}
                    className="btn-close"
                  ></Button>
                </Col>
              </Row>

              <Label className="text-danger">
                (ประเภท PDF, JPEG, PNG และขนาดไฟล์ไม่เกิน 25 MB)
              </Label>

            {configForm?.form_type === 7 && <Label className="text-danger">
              *ต้องแนบหนังสืออนุมัติไปศึกษา ฝึกอบรม ดูงาน ประชุม หรือปฏิบัติการวิจัย
            </Label>}
            </Col>
          </FormGroup>
          <FormGroup></FormGroup>
          <FormGroup row style={{ display: "flex", alignItems: "center" }}>
            <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
              {leaveConfigFlowData.sendToFinal ? 'ส่งผู้อนุมัติ' : 'ส่งผู้อนุญาต'}
            </Label>
            <Col xs={9} xl={4} lg={9} md={9}>
              <Input
                readOnly
                disabled
                value={data?.approve_user}
                type="text"
                onChange={(e) => handleInputChange(e, "approve_user")}
              />
            </Col>
          </FormGroup>
          <FormGroup row style={{ display: "flex", justifyContent: "end" }}>
            <Col xl={3} lg={6}>
              <Button
                disabled = {submitSending}
                className="mt-2"
                color="success"
                type="submit"
                style={{ width: "100%" }}
              >
                {/* <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> */}
                {submitSending ? (<i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>) : 'บันทึกและส่ง'}
              </Button>
            </Col>
            <Col xxl={3} lg={6}>
              <Button className="mt-2" color="danger" style={{ width: "100%" }}>
                ปิด
              </Button>
            </Col>
          </FormGroup>
        </Form>)
      ) : null}
    </React.Fragment>
  );
};

export default Form1;
